var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initFlags, setFlags } from './actions';
import { addCalculatedFlags } from '@wix/da-react-context/pkg/flags/helpers';
var actionHandlers = handleActions((_a = {},
    _a[initFlags.toString()] = function (state, _a) {
        var flags = _a.payload.flags;
        return addCalculatedFlags(flags);
    },
    _a[setFlags.toString()] = function (state, _a) {
        var flags = _a.payload.flags;
        return addCalculatedFlags(__assign(__assign({}, state), flags));
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map